import { Box, Button, } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import { PropCustomize } from './customization/Index'
import { ArrowBack } from '@mui/icons-material'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { ToolContext } from '../../../../../../../core/context/ToolContext'
import { domain, env } from '../../../../../../../core/Env'
import { rqx } from '../../../../../../../core/request/API'
import { S3 } from '../../../../../../../core/transmit/S3'
import { SnakeLoader } from '../../../../../../../core/loader/SnakeLoader'
import { Confirmation, TopButton } from '../../modal/Index'

const hcrmSession = JSON.parse(localStorage.getItem('hcrm_session'))
export const CustomizationProperty = ({ match }) => {
    const { salespage_state, tool_state } = useContext(ToolContext)
    const { userId, __SESSION } = tool_state
    const { cmtznLoader, t_form, error, openConfirm, leftBar, opentxtfld } = salespage_state;
    const history = useHistory()
    const urlparams = new URLSearchParams(window.location.search)
    const params = match.params.action
    const backHandler = () => {
        if (t_form.data.method === 'update') {
            history.push(`/campaign/sales_page?type=property`)
        }else{
            history.push(`/campaign/sales_page?type=property&option=attract`)
        }
    }
    const inputs = t_form.data.styles
    const submitHandler = (status) => {
        t_form.set({ ...t_form.data, submit: { modal: true, type: status, confirmed: false } })
        if (inputs.names.images.first_img.type === 'default' || inputs.names.images.second_img.type === 'default' || inputs.names.images.third_img.type === 'default' || inputs.names.images.fourth_img.type === 'default' || inputs.names.images.fifth_img.type === 'default' || inputs.names.images.sixth_img.type === 'default' || inputs.names.images.owner_img.type === 'default') {
            error.set({...error.data, proceed: true})
            t_form.set({ ...t_form.data, submit: { modal: false, type: status, confirmed: false } })
        } else {
            t_form.set({ ...t_form.data, submit: { modal: true, type: status, confirmed: false } })
            error.set({...error.data, proceed: false})
        }
    }

    const proceedHandler = async () => {
        if (hcrmSession === null) {

            let fst = await S3([inputs.names.images.first_img.value])
            let snd = await S3([inputs.names.images.second_img.value])
            let trd = await S3([inputs.names.images.third_img.value])
            let frt = await S3([inputs.names.images.fourth_img.value])
            let fft = await S3([inputs.names.images.fifth_img.value])
            let sxt = await S3([inputs.names.images.sixth_img.value])
            let own = await S3([inputs.names.images.owner_img.value])

            let jstr = JSON.stringify({
                ...t_form.data, styles: {
                    ...inputs, names: {
                        ...inputs.names, images: {
                            ...inputs.names.images,
                            first_img: { ...inputs.names.images.first_img, link: fst.location },
                            second_img: { ...inputs.names.images.second_img, link: snd.location },
                            third_img: { ...inputs.names.images.third_img, link: trd.location },
                            fourth_img: { ...inputs.names.images.fourth_img, link: frt.location },
                            fifth_img: { ...inputs.names.images.fifth_img, link: fft.location },
                            sixth_img: { ...inputs.names.images.sixth_img, link: sxt.location },
                            owner_img: { ...inputs.names.images.owner_img, link: own.location },
                        }
                    }
                }
            })
           
            localStorage.setItem('cb_real_property', jstr)
            let subId = env() === 'dev' || env() === 'local' ? 'c3Vic2NyaXB0aW9uXzUzMA==' : env() === 'sb'? 'c3Vic2NyaXB0aW9uXzM3Mg==' : 'c3Vic2NyaXB0aW9uXzI2NQ=='
            window.location.href = `${domain('mp').url}/subscription/checkout/rqx?tid=${window.btoa(`tool_${process.env.REACT_APP_TID_BIZ}`)}&callback=${process.env.REACT_APP_ENV}&platform=business&subscription=${subId}&ref=unauth&auth_type=registration&entry=ubr_subtool&subcb=ubr_real_property`

        } else {
            t_form.set({ ...t_form.data, submit: { ...t_form.data.submit, confirmed: true } })

            let fst = { location: `${t_form.data.method === "create" ? domain('tool').url : ''}${inputs.names.images.first_img.object}` }
            let snd = { location: `${t_form.data.method === "create" ? domain('tool').url : ''}${inputs.names.images.second_img.object}` }
            let trd = { location: `${t_form.data.method === "create" ? domain('tool').url : ''}${inputs.names.images.third_img.object}` }
            let frt = { location: `${t_form.data.method === "create" ? domain('tool').url : ''}${inputs.names.images.fourth_img.object}` }
            let fft = { location: `${t_form.data.method === "create" ? domain('tool').url : ''}${inputs.names.images.fifth_img.object}` }
            let sxt = { location: `${t_form.data.method === "create" ? domain('tool').url : ''}${inputs.names.images.sixth_img.object}` }
            let own = { location: `${t_form.data.method === "create" ? domain('tool').url : ''}${inputs.names.images.owner_img.object}` }

            if (inputs.names.images.first_img.type !== 'default') fst = await S3([inputs.names.images.first_img.value])
            if (inputs.names.images.second_img.type !== 'default') snd = await S3([inputs.names.images.second_img.value])
            if (inputs.names.images.third_img.type !== 'default') trd = await S3([inputs.names.images.third_img.value])
            if (inputs.names.images.fourth_img.type !== 'default') frt = await S3([inputs.names.images.fourth_img.value])
            if (inputs.names.images.fifth_img.type !== 'default') fft = await S3([inputs.names.images.fifth_img.value])
            if (inputs.names.images.sixth_img.type !== 'default') sxt = await S3([inputs.names.images.sixth_img.value])
            if (inputs.names.images.owner_img.type !== 'default') own = await S3([inputs.names.images.owner_img.value])

            const p = {
                id: t_form.data.id,
                company_id: __SESSION.data.uaccess[0].company_id,
                name: t_form.data.name,
                status: t_form.data.submit.type,
                active: 1,
                url: `${domain('shp').url}/psl/sales_page/realproperty`,
                template_section_id: parseInt(t_form.data.template_section_id),
                template_id: t_form.data.template_id,
                content: {
                    contact_name: inputs.names.contact_name.value,
                    contact_number: inputs.names.contact_number.value,
                    facebook: inputs.names.facebook.value,
                    twitter: inputs.names.twitter.value,
                    instagram: inputs.names.instagram.value,
                    title: inputs.names.title.value,
                    title_description: inputs.names.title_description.value,
                    start_price: inputs.names.start_price.value,
                    price: inputs.names.price.value,
                    buttons: {
                        first: { label: inputs.names.buttons.first.label, link: inputs.names.buttons.first.link },
                        second: { label: inputs.names.buttons.second.label, link: inputs.names.buttons.second.link }
                    },
                    bestfor_title: inputs.names.bestfor_title.value,
                    bestfor_items: inputs.names.bestfor_items.map((i) => {
                        if (t_form.data.method === 'create') {
                            return i.value
                        }
                        return i.value
                    }),
                    feature_title: inputs.names.feature_title.value,
                    feature_items: inputs.names.feature_items.map((i) => {
                        if (t_form.data.method === 'create') {
                            return i.value
                        }
                        return i.value
                    }),
                    atp_title: inputs.names.atp_title.value,
                    atp_description: inputs.names.atp_description.value,
                    owner_name: inputs.names.owner_name.value,
                    owner_title: inputs.names.owner_title.value,
                    owner_description: inputs.names.owner_description.value,
                    contact_title: inputs.names.contact_title.value,
                    cellphone_num: inputs.names.cellphone_num.value,
                    telephone_num: inputs.names.telephone_num.value,
                    social_title: inputs.names.social_title.value,
                    images: {
                        first_img: fst.location,
                        second_img: snd.location,
                        third_img: trd.location,
                        fourth_img: frt.location,
                        fifth_img: fft.location,
                        sixth_img: sxt.location,
                        owner_img: own.location,
                    },
                },
                design: { fontColor: '#FFFFFF', fontSize: 14, font: 'Inter' },
                user_id: userId.data,
            }
            const s = await rqx.post(`<<tool>>/${env()}/realProperty/${t_form.data.method}`, p)
            if (s.message === 'success') {
                openConfirm.set(false)
                history.push(`/campaign/sales_page?type=property`)
            }
        }
    }
    const __init = async () => {
        t_form.set({})
        cmtznLoader.set(true)
        const t = await rqx.get(`<<tool>>/${env()}/realProperty/viewTemplate`, { id: urlparams.get('id'), section_id: urlparams.get('section_id') })
        t_form.set({
            ...t_form.data,
            method: 'create',
            submit: { modal: false, type: "", confirmed: false },
            url: "",
            id: t[0].id,
            name: '',
            template_section_id: urlparams.get('section_id'),
            template_id: t[0].template_id,
            styles: JSON.parse(t[0].designs),
            status: t[0].status,
        })
        cmtznLoader.set(false)
    }
   

    const __viewlist = async () => {
        cmtznLoader.set(true)
        const l = await rqx.get(`<<tool>>/${env()}/realProperty/viewList`, {
            id: urlparams.get('id'), section_id: urlparams.get('section_id')
        })
        let content = JSON.parse(l[0].content)
        t_form.set({
            ...t_form.data,
            method: 'update',
            submit: { modal: false, type: "", confirmed: false },
            url: "",
            id: l[0].id,
            name: l[0].name,
            template_section_id: urlparams.get('section_id'),
            template_id: l[0].template_id,
            status: l[0].status,
            styles: {
                designs: JSON.parse(l[0].design),
                names: {
                    contact_name: {value: content.contact_name, msg: '', stat: ''},
                    contact_number: {value: content.contact_number, msg: '', stat: ''},
                    facebook: {value: content.facebook, msg: '', stat: ''},
                    twitter: {value: content.twitter, msg: '', stat: ''},
                    instagram: {value: content.instagram, msg: '', stat: ''},
                    atp_description: { value: content.atp_description, msg: '', stat: '' },
                    atp_title: { value: content.atp_title, msg: '', stat: '' },
                    bestfor_items: content.bestfor_items.map((v) => ({ value: v, stat: false, msg: '' })),
                    bestfor_title: { value: content.bestfor_title, msg: '', stat: '' },
                    buttons: {
                        first: { label: content.buttons.first.label, link: content.buttons.first.link },
                        second: { label: content.buttons.second.label, link: content.buttons.second.link }
                    },
                    cellphone_num: { value: content.cellphone_num, msg: '', stat: '' },
                    contact_title: { value: content.contact_title, msg: '', stat: '' },
                    feature_title: { value: content.feature_title, msg: '', stat: '' },
                    feature_items: content.feature_items.map((v) => ({ value: v, stat: false, msg: '' })),
                    images: {
                        first_img: { value: 'default_avatar', object: content.images.first_img, type: 'default', size: 0, updated: false, },
                        second_img: { value: 'default_avatar', object: content.images.second_img, type: 'default', size: 0, updated: false, },
                        third_img: { value: 'default_avatar', object: content.images.third_img, type: 'default', size: 0, updated: false, },
                        fourth_img: { value: 'default_avatar', object: content.images.fourth_img, type: 'default', size: 0, updated: false, },
                        fifth_img: { value: 'default_avatar', object: content.images.fifth_img, type: 'default', size: 0, updated: false, },
                        sixth_img: { value: 'default_avatar', object: content.images.sixth_img, type: 'default', size: 0, updated: false, },
                        owner_img: { value: 'default_avatar', object: content.images.owner_img, type: 'default', size: 0, updated: false, },
                    },
                    owner_description: { value: content.owner_description, msg: '', stat: '' },
                    owner_name: { value: content.owner_name, msg: '', stat: '' },
                    owner_title: { value: content.owner_title, msg: '', stat: '' },
                    price: { value: content.price, msg: '', stat: '' },
                    start_price: { value: content.start_price, msg: '', stat: '' },
                    social_title: { value: content.social_title, msg: '', stat: '' },
                    telephone_num: { value: content.telephone_num, msg: '', stat: '' },
                    title: { value: content.title, msg: '', stat: '' },
                    title_description: { value: content.title_description, msg: '', stat: '' },
                }
            }
        })
        cmtznLoader.set(false)
    }

    useEffect(() => {
        if (match.params.action === 'create') {
            __init()
        } else {
            __viewlist()
        }
        // eslint-disable-next-line
    }, [match.params.action])
    return (
        <Box display="flex" alignItems="center" flexDirection="column" width="100%" height="100%">

            <Box position="fixed" display="flex" alignItems="center" justifyContent="space-between" width="100%" bgcolor="#fff" height={56} sx={{ boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.12)', zIndex: 1201 }} p={2}>
                <Box display="flex" alignItems="center" gap={1} height={72} px={2} sx={{ cursor: 'pointer' }} onClick={backHandler}>
                    <ArrowBack sx={{ color: '#009F4D', fontSize: 22 }} />
                    <Box>Back</Box>
                </Box>
                <Box display="flex" gap={2}>
                    {   
                        hcrmSession !== null && (t_form.data.status === undefined || t_form.data.status === 1) &&
                        <Box component={Button} bgcolor="#e3e3e3" color="#009F4D" borderRadius={2} width={138} sx={{ ':hover': { bgcolor: '#e3e3e3' }, "&:disabled": { bgcolor: '#A4C5B4', color: '#E5F2EC' } }} onClick={() => submitHandler(1)}>Save as Draft</Box>
                    }
                    <Box component={Button} bgcolor="#0876F8" color="#fff" borderRadius={2} width={138} sx={{ ':hover': { bgcolor: '#0876F8' }, "&:disabled": { bgcolor: '#7993B1', color: '#F5F5F5' } }} onClick={() => submitHandler(2)}>Post</Box>
                </Box>
            </Box>
            <Box width="100%" height="100%">
                {
                    cmtznLoader.data ?
                        <Box pt={30} display="flex" justifyContent="center" alignItems="center" flexDirection="column" my={5} >
                            <SnakeLoader size="14px" bg="#009F4D" distance="0.3rem" />
                        </Box>
                        :
                        <>
                            <PropCustomize params={params} t_form={t_form} proceedHandler={proceedHandler} error={error} openConfirm={openConfirm} leftBar={leftBar} opentxtfld={opentxtfld} />
                            <TopButton t_form={t_form} openConfirm={openConfirm} error={error} />
                            <Confirmation proceedHandler={proceedHandler} open={openConfirm.data} typeof_page={t_form.data.submit.type === 1 ? 'Save' : 'Post'} message={t_form.data.submit.type === 1 ? 'This will not be available online yet.' : 'This will be available online.'} t_form={t_form} close={() => openConfirm.set(false)} />
                        </>
                }
            </Box>
        </Box>
    )
}




